<template>
  <div class="download-stat">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据下载记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item  label="数据类别">
          <el-select  size="mini" v-model="searchParams.type" style="width:200px;" 
                      filterable placeholder="Proposal/GRB/SEM/UPK" clearable >
                  <el-option
                      v-for="item in filedataltype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="数据 ID">
          <el-input size="mini" style="width: 200px"  v-model="searchParams.ogs_id"></el-input>
        </el-form-item> 
        <el-form-item label="用户 ID">
          <el-input size="mini"  v-model="searchParams.user_id"></el-input>
        </el-form-item> 
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        style="width: 100%"
        @sort-change="sortChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="id"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别">
        </el-table-column>
        <el-table-column
          prop="ogs_id"
          sortable="custom"
          label="数据ID">
        </el-table-column>
        <el-table-column
          prop="level"
          sortable="custom"
          label="数据级别">
        </el-table-column>
        <el-table-column
          prop="file_id"
          sortable="custom"
          label="文件ID">
        </el-table-column>
        <el-table-column
          prop="email"
          sortable="custom"
          label="邮件地址">
        </el-table-column>
        <el-table-column
          prop="user_id"
          sortable="custom"
          label="用户ID">
        </el-table-column>
        <el-table-column
          prop="stime"
          sortable="custom"
          label="开始时间">
        </el-table-column>
        <!-- <el-table-column
          prop="timelength"
          label="下载时长">
        </el-table-column>
        <el-table-column
          prop="speed"
          label="平均速度">
        </el-table-column> -->
        <!-- <el-table-column
          prop="failure"
          label="是否完成下载">
        </el-table-column> -->
        <el-table-column
          prop="ip"
          sortable="custom"
          label="下载方IP">
        </el-table-column>
        <el-table-column
          prop="tools"
          label="下载工具">
        </el-table-column>  
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {downfiletype} from '../common';
import axios from 'axios';

export default {
  name: 'DownloadStat',
  data() {
    return {
      searchParams: {
        ogs_id: '',
        user_id: '',
        type: '',
      },
      list: [],
      filedataltype: downfiletype,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      orderDirection: null,
      orderProp: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/DownloadStat', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getData();
    },

  },
};
</script>

<style scoped>
.download-stat {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>